export default __webpack_public_path__ + "static/media/shuffle-icon.eafed983.svg";